import { Filter } from './../types';

declare global {
  interface Array<T> {
    filterSelected<T extends Filter.Selectable>(): T[];
    nothingSelected<T extends Filter.Selectable>(): boolean;
    allSelected<T extends Filter.Selectable>(): boolean;
  }
}

Array.prototype.filterSelected = function <T>(): T[] {
  return this.filter((it) => it.selected) as T[];
};

Array.prototype.nothingSelected = function (): boolean {
  return this.every((it) => !it.selected);
};

Array.prototype.allSelected = function (): boolean {
  return this.every((it) => it.selected);
};
